import React, {Component} from 'react';


class FileWritingGif extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            text : ''
        }
    }
    componentDidMount() {
        let texts = ["Initializing Data ...","Gathering DBQ form ...","Sending Responses to DBQ ...", "Finalizing DBQ ..."];
        let index = 0;
        this.setState({text : texts[index]})
                this.interval = setInterval(() => {
                    this.setState({ text: texts[++index] })
                    if (index === (texts.length - 1)) {
                        index = texts.length - 2
                    }
                }, 500);
      }
      componentWillUnmount() {
        clearInterval(this.interval);
      }
    render() {
        return (
            <div className="overlay-msg" >
                <div className="overlay-box">
                    <h1 className='gif-file-msg-heading'>Your DBQ Form is Generating</h1>
                    <h6 className="gif-file-msg-status">{this.state.text}</h6>
                    <img src="/imgs/app/vbg-icons/gif/document.gif" alt="DBQ is being written ..."/>
                </div>
            </div>
        );
    }
}

export default FileWritingGif